import { apiClient } from "./api";

// Per-tenant hiring configuration.
//
// Note there is no store_id parameter anywhere below, and that is deliberate:
// the backend derives the tenant from the session token's claims. If a call here
// ever needs a store_id, something has regressed — the client must not be able to
// name its own tenant.
export const tenantSettingsService = {
  // → { provisioned: false, store_id } when the tenant has no settings row yet,
  //   { provisioned: true, ...settings, secrets, readiness } once provisioned.
  get: () => apiClient.get("/tenant-settings"),

  provision: (settings = {}) =>
    apiClient.post("/tenant-settings/provision", settings),

  // Partial update. Fields outside the server's allowlist come back in
  // `ignored_fields` rather than failing the request.
  update: (patch) => apiClient.patch("/tenant-settings", patch),

  spend: () => apiClient.get("/tenant-settings/spend"),

  // Write-only. field ∈ 'google_refresh_token' | 'ai_api_key'.
  // The response confirms storage and returns a masked hint, never the value.
  setSecret: (field, value) =>
    apiClient.put(`/tenant-settings/secret/${field}`, { value }),

  clearSecret: (field) => apiClient.delete(`/tenant-settings/secret/${field}`),
};

// Human labels for the readiness checklist the API returns.
export const READINESS_LABELS = {
  legal_entity_name: "Legal entity name (used in the consent notice)",
  display_name: "Display name shown to candidates",
  mail_from_address: "Sender email address",
  consent_text: "Data-use consent text",
  recording_consent_text: "Video recording consent text",
  consent_version: "Consent version label",
  mail_domain_verified: "Sending domain verified (platform sets this)",
};
